export function XPayPaymentHandler(paymentLink) {
  window.open(paymentLink, "_self");
}